/* eslint-disable no-magic-numbers */
import { Collapse, styled } from "@mui/material";
import { Link } from "react-router-dom";
import { routes } from "routes";
import RoundButton from "../../components/buttons/RoundButton";
import { Container, ExpandableCard, FaqAnswerP, H1, P500, SubHeader } from "./StaticPagesComponents";
import plusIcon from "components/icons/plusIcon.svg";
import minusIcon from "components/icons/minusIcon.svg";
import { Fragment, useState } from "react";
import colors from "../../theme/themeConstants";
import { FooterAds } from "../../components/ads/FooterAds";

const MOCK_FREQUENT_QUESTIONS = [
  {
    question: "How do I delete my account?",
    answer:
      (
        <>
          To delete your account, please email <a href={"mailto:accountdeletions@redgifs.com?subject=Delete%20my%20Account"}
          > accountdeletions@redgifs.com </a><br /><br />
          Please also note that the user is responsible for deleting content prior to RedGIFs deleting the profile.
          All GIFs remaining on a deleted profile will be anonymised and removed from search indexes.
          They will still however be available through the link.
        </>
      )
  },
  {
    question: "How do I change my Profile Name?",
    answer:
      (
        <>
          Please click <Link to={routes.profileSettings()}>here</Link> to update your Profile Name
        </>
      )
  },
  {
    question: "Where do I update my email?",
    answer:
      (
        <>
          Please click <Link to={routes.accountSettings()}>here</Link> to update the email account associated with your account
        </>
      )
  },
  {
    question: "How to reset my password?",
    answer:
      (
        <>
          Please click <Link to={routes.accountSettings()}>here</Link> to Reset Password
        </>
      )
  },
  {
    question: "How to delete my GIFs?",
    answer:
      (
        <>
          To delete a GIF please navigate to your Manage section, select the desired GIF and hit the delete button.
        </>
      )
  },

  {
    question: "How do I upload?",
    answer:
      (
        <>
          To upload, simply click the plus icon! Uploads can be made via local file or URL.
        </>
      )
  },
  {
    question: "My Upload is stuck on Uploading/Encoding",
    answer:
      (
        <>
          If the Upload has failed it will first appear ‘stuck’ before displaying the upload failure reason.
        </>
      )
  },
  {
    question: "What is the maximum file size for upload?",
    answer:
      (
        <>
          1 GB
        </>
      )
  },
  {
    question: "Sharing Content on Reddit",
    answer:
      (
        <>
          In order for your RedGIF to autoplay on Reddit all you need to do is copy the link and create a link post
          (please ensure the subreddit is NSFW). We are perfectly integrated with Reddit and your GIF will autoplay.
          In order to share Images please use the Reddit share option to retrieve the correct image sharing link.
        </>
      )
  },
  {
    question: "Sharing Content on Twitter",
    answer:
      (
        <>
          In order for your RedGIF to autoplay on Twitter all you need to do is copy the link and create a post.
          We are perfectly integrated with Twitter and your GIF will autoplay.
        </>
      )
  },
  {
    question: "Sharing Content on Discord",
    answer:
      (
        <>
          In order for your RedGIF to autoplay on Discord all you need to do is copy the link and create a post.
          We are perfectly integrated with Discord and your GIF will autoplay.
        </>
      )
  },
  {
    question: "How do I report a user?",
    answer:
      (
        <>
          To report a user you suspect of going against our terms of service, please email
          <a href="mailto:support@redgifs.com?subject=Report%20suspicious%20user"> support@redgifs.com</a> with the Profile URL and reason for report.
        </>
      )
  },
  {
    question: "How do I report a GIF?",
    answer:
      (
        <>
          All GIFs have a ‘Report’ function. Please click here and follow instructions for GIF reporting.
        </>
      )
  },
  {
    question: "I am in a GIF I did not Upload",
    answer:
      (
        <>
          Please see <Link to={routes.dmca()}>here</Link> for our DMCA instructions
        </>
      )
  },

];

export const FAQPage = () => {
  const [expandedQuestions, setExpandedQuestions] = useState<Set<number>>(new Set());

  const handleExpand = (index: number) => () => {
    if (expandedQuestions.has(index)) {
      setExpandedQuestions((prev) => {
        prev.delete(index);
        return new Set(prev);
      });
    } else {
      setExpandedQuestions((prev) => {
        prev.add(index);
        return new Set(prev);
      });
    }
  };

  return (
    <Fragment>
      <Container className="page narrow" sx={{ "& h4": { marginTop: "40px" } }}>
        <H1>
          Frequently Asked Questions
        </H1>

        <SubHeader>
          My Account
        </SubHeader>

        <ExpandableCardsContainer>
          {MOCK_FREQUENT_QUESTIONS.slice(0, 5).map((question, index) => (
            <ExpandableCard
              key={index}
              sx={{ cursor: "pointer" }}
            >
              <div
                id="expandable-card-question"
                onClick={handleExpand(MOCK_FREQUENT_QUESTIONS.indexOf(question))}
              >
                <P500>
                  {question.question}
                </P500>
                <RoundButton
                  img={expandedQuestions.has(MOCK_FREQUENT_QUESTIONS.indexOf(question)) ? minusIcon : plusIcon}
                  imgSize={"10px"}
                  bgColor={colors.redPink}
                ></RoundButton>
              </div>

              <Collapse in={expandedQuestions.has(MOCK_FREQUENT_QUESTIONS.indexOf(question))} timeout="auto" unmountOnExit>
                <FaqAnswerP>
                  {question.answer}
                </FaqAnswerP>
              </Collapse>
            </ExpandableCard>
          ))}
        </ExpandableCardsContainer>

        <SubHeader>
          Uploading
        </SubHeader>

        <ExpandableCardsContainer>
          {MOCK_FREQUENT_QUESTIONS.slice(5, 8).map((question, index) => (
            <ExpandableCard key={index}>
              <div
                id="expandable-card-question"
                onClick={handleExpand(MOCK_FREQUENT_QUESTIONS.indexOf(question))}
              >
                <P500>
                  {question.question}
                </P500>
                <RoundButton
                  img={expandedQuestions.has(MOCK_FREQUENT_QUESTIONS.indexOf(question)) ? minusIcon : plusIcon}
                  imgSize={"10px"}
                  bgColor={colors.redPink}
                ></RoundButton>
              </div>

              <Collapse in={expandedQuestions.has(MOCK_FREQUENT_QUESTIONS.indexOf(question))} timeout="auto" unmountOnExit>
                <FaqAnswerP>
                  {question.answer}
                </FaqAnswerP>
              </Collapse>
            </ExpandableCard>
          ))}
        </ExpandableCardsContainer>

        <SubHeader>
          Sharing Content
        </SubHeader>

        <ExpandableCardsContainer>
          {MOCK_FREQUENT_QUESTIONS.slice(8, 11).map((question, index) => (
            <ExpandableCard key={index}>
              <div
                id="expandable-card-question"
                onClick={handleExpand(MOCK_FREQUENT_QUESTIONS.indexOf(question))}
              >
                <P500>
                  {question.question}
                </P500>
                <RoundButton
                  img={expandedQuestions.has(MOCK_FREQUENT_QUESTIONS.indexOf(question)) ? minusIcon : plusIcon}
                  imgSize={"10px"}
                  bgColor={colors.redPink}
                ></RoundButton>
              </div>

              <Collapse in={expandedQuestions.has(MOCK_FREQUENT_QUESTIONS.indexOf(question))} timeout="auto" unmountOnExit>
                <FaqAnswerP>
                  {question.answer}
                </FaqAnswerP>
              </Collapse>
            </ExpandableCard>
          ))}
        </ExpandableCardsContainer>

        <SubHeader>
          Problematic Content
        </SubHeader>

        <ExpandableCardsContainer>
          {MOCK_FREQUENT_QUESTIONS.slice(11, 13).map((question, index) => (
            <ExpandableCard key={index}>
              <div
                id="expandable-card-question"
                onClick={handleExpand(MOCK_FREQUENT_QUESTIONS.indexOf(question))}
              >
                <P500>
                  {question.question}
                </P500>
                <RoundButton
                  img={expandedQuestions.has(MOCK_FREQUENT_QUESTIONS.indexOf(question)) ? minusIcon : plusIcon}
                  imgSize={"10px"}
                  bgColor={colors.redPink}
                ></RoundButton>
              </div>

              <Collapse in={expandedQuestions.has(MOCK_FREQUENT_QUESTIONS.indexOf(question))} timeout="auto" unmountOnExit>
                <FaqAnswerP>
                  {question.answer}
                </FaqAnswerP>
              </Collapse>
            </ExpandableCard>
          ))}
        </ExpandableCardsContainer>

      </Container >

      <FooterAds/>
    </Fragment>
  );
};

const ExpandableCardsContainer = styled("div")({

});
